import { render } from "./CareerBanner.vue?vue&type=template&id=202189bf&scoped=true"
import script from "./CareerBanner.vue?vue&type=script&lang=js"
export * from "./CareerBanner.vue?vue&type=script&lang=js"

import "./CareerBanner.vue?vue&type=style&index=0&id=202189bf&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202189bf"]])

export default __exports__